// extracted by mini-css-extract-plugin
export default {"container":"Home_container__5xSil","studyManagerLbl":"Home_studyManagerLbl__o+T4u"};